import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import SimpleBackdrop from "../../utils/general.js";
import api from "../../utils/api.js";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant.js";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField";
import Loader from "components/Shared/Loader/Loader";
import { Autocomplete } from "@material-ui/lab";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
class ProductMaster extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      MasterID: "",
      loading: false,
      UserId: "",
      Token: "",
      GetMasterList: [],
      rowsPerPageOptions: CommonConfig.dataTableConfig.rowsPerPageOptions,
      rowsPerPage: CommonConfig.dataTableConfig.rowsPerPage,
      search: null,

      type: [],

      AddMasterModal: false,
      EditMasterTypeModal: false,
      DeleteMasterTypeModal: false,
      cargoTypeList: [],
      typeList: [],
      userPageAccess: [],
    };
  }

  componentDidMount = async () => {
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");
    // if (lockstatus == 0) {
    if (token !== null) {
      this.setState({
        UserId: data,
        Token: token,
        userPageAccess: userPageAccess,
      });
      await this.GetMasterListByType(data);
      await this.GetTypeMaster(data);
    } else {
      this.props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  };

  actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {this.state.userPageAccess.includes("Edit Product") ? (
          <div onClick={(e) => this.handleOpen(rowData, "EditMasterType")}>
            {" "}
            <i class="icon-editImage"></i>{" "}
          </div>
        ) : null}
        {this.state.userPageAccess.includes("Delete Product") ? (
          <div onClick={(e) => this.handleOpen(rowData, "DeleteMasterType")}>
            {" "}
            <i class="icon-delete"></i>{" "}
          </div>
        ) : null}
      </div>
    );
  };

  GetMasterListByType = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetProductMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          this.setState({ GetMasterList: response.Data });
        }
      })
      .catch((err) => {});
  };

  GetProductMasterById = async (MasterId) => {
    Loader.show();
    let params = {
      MasterId,
    };
    api
      .post(APIConstant.path.GetProductMasterById, params)
      .then((response) => {
        if (response.Success === 1) {
          Loader.hide();

          let type = response.Data.Type;
          if (typeof type === "string") {
            type = [type];
          }
          this.setState({
            productName: response.Data.ProductName,
            type: type,
            MasterID: response.Data.ProductMasterId,
          });
        } else {
          Loader.hide();
        }
      })
      .catch((err) => {
        Loader.hide();
      });
  };

  GetTypeMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetTypeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserID != "Admin");

          this.setState({ typeList: filterArry });
        }
      })
      .catch((err) => {});
  };

  handleOpen = (item, type) => {
    if (type === "AddMaster") {
      this.setState({ AddMasterModal: true });
    } else if (type === "EditMasterType") {
      this.GetProductMasterById(item.ProductMasterId);
      this.setState({
        AddMasterModal: true,
        MasterLabelName: item.label,
        MasterID: item.ProductMasterId,
      });
    } else if (type === "DeleteMasterType") {
      this.setState({
        DeleteMasterTypeModal: true,
        MasterID: item.ProductMasterId,
      });
    }
  };

  handleClose = (type) => {
    if (type === "AddMaster") {
      this.setState({
        AddMasterModal: false,

        productName: "",
        productNameErr: false,
        productNameErrText: "",

        type: [],

        MasterID: "",
      });
    } else if (type === "EditMasterType") {
      this.setState({ EditMasterTypeModal: false });
    } else if (type === "DeleteMasterType") {
      this.setState({ DeleteMasterTypeModal: false, MasterID: "" });
    }
  };

  handleChange = (e, type) => {
    if (type === "productName") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          productName: e.target.value,
          productNameErr: true,
          productNameErrText: `Please enter Product Name.`,
        });
      } else {
        this.setState({
          productName: e.target.value,
          productNameErr: false,
          productNameErrText: "",
        });
      }
    } else if (type === "type") {
      const selectedTypes = [...this.state.type];
      const index = selectedTypes.indexOf(e.value);

      if (index === -1) {
        selectedTypes.push(e.value);
      } else {
        selectedTypes.splice(index, 1);
      }

      this.setState({ type: selectedTypes });
    }
  };

  validation = () => {
    let formIsValid = true;
    if (CommonConfig.isEmpty(this.state.productName)) {
      this.setState({
        productName: "",
        productNameErr: true,
        productNameErrText: "Type is required.",
      });
      formIsValid = false;
    } else {
      this.setState({ productNameErr: false, productNameErrText: "" });
    }

    if (CommonConfig.isEmpty(this.state.type)) {
      cogoToast.error("Type is required");
      formIsValid = false;
    }
    return formIsValid;
  };

  AddMaster = () => {
    if (this.validation()) {
      this.setState({ loading: true });

      let params = {
        ProductName: this.state.productName,
        Type: this.state.type,
        ProductMasterID: this.state.MasterID,
        UserID: this.state.UserId,
      };
      api.post(APIConstant.path.AddUpdateProductMaster, params).then((res) => {
        if (res.Success == 1) {
          this.setState({ loading: false });
          this.handleClose("AddMaster");
          this.GetMasterListByType(this.state.UserId);
          cogoToast.success(res.Message);
        } else {
          this.setState({ loading: false });
          cogoToast.error(res.Message);
        }
      });
    }
  };

  DeleteMasterType = () => {
    this.setState({ loading: true });
    let params = {
      ID: this.state.MasterID,
      UserId: this.state.UserId,
    };
    api.post(APIConstant.path.DeleteProductMaster, params).then((res) => {
      if (res.Success == 1) {
        this.setState({
          loading: false,
          DeleteMasterTypeModal: false,
          MasterID: "",
        });
        this.GetMasterListByType(this.state.UserId);
        cogoToast.success(res.Message);
      } else {
        this.setState({ loading: false });
        cogoToast.error(res.Message);
      }
    });
  };
  GetCargoTypeList = (UserId) => {
    let params = {
      Type: "CARGOTYPE",
      ID: UserId,
    };
    api.post(APIConstant.path.GetMasterListByType, params).then(async (res) => {
      if (res.Success === 1) {
        this.setState({ cargoTypeList: res.Info.Master });
      }
    });
  };

  render() {
    const {
      typeList,
      search,
      userPageAccess,
      GetMasterList,
      AddMasterModal,
      DeleteMasterTypeModal,
      MasterID,

      productName,
      productNameErr,
      productNameErrText,
      type,
    } = this.state;

    let filterGetMasterList = [];
    if (GetMasterList.length) {
      filterGetMasterList = GetMasterList;
      if (search) {
        filterGetMasterList = filterGetMasterList.filter((x) => {
          let condition =
            typeof x.Type === "string"
              ? x.Type.toLowerCase().indexOf(search.toLowerCase()) !== -1
              : x.Type.join(", ")
                  .toLowerCase()
                  .indexOf(search.toLowerCase()) !== -1;
          return (
            x.ProductName.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
            condition
          );
        });
      }
    }

    return (
      <div className="wayment-owner-dashboard e-weighment-dashoard">
        <div className="heading-area p-d-flex p-ai-center p-jc-between">
          <div className="p-d-flex p-ai-center">
            <i className="pi pi-box"></i>
            <h2>Product Master</h2>
          </div>
          <div className="p-d-flex p-ai-center wb-filter-btn">
            <div className="searchbar-area p-as-center">
              <InputText
                type="search"
                onInput={(e) => this.setState({ search: e.target.value })}
                placeholder="Global Search"
                size="30"
                style={{ marginRight: 10 }}
              />
              <i className="icon-search"></i>
            </div>
            {userPageAccess.includes("Add Product") ? (
              <div>
                <div
                  className="e-add-btn"
                  onClick={(e) => this.handleOpen(e, "AddMaster")}
                >
                  <i className="icon-add"></i>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <hr />
        <div className="main-access-card-master">
          {this.state.loading === true ? (
            <div className="loading">
              <SimpleBackdrop />
            </div>
          ) : null}
          {userPageAccess.includes("View Product") ? (
            <DataTable
              className="main-table table-td"
              value={filterGetMasterList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              paginator={true}
              rows={this.state.rowsPerPage}
              totalRecords={filterGetMasterList.length}
              rowsPerPageOptions={this.state.rowsPerPageOptions}
              globalFilter={search}
              emptyMessage="No records found"
              responsive={false}
              resizableColumns={true}
              columnResizeMode="fit"
              scrollable={true}
              scrollWidth="auto"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            >
              <Column
                field="Index"
                header="Sr.No"
                body={this.actionBodyTemplateSrNo}
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="ProductName"
                header="Product Name"
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="Type"
                header="Type"
                style={{ width: "20%" }}
                body={(rowData) => {
                  if (typeof rowData.Type === "string") {
                    return rowData.Type;
                  } else {
                    return rowData.Type.join(", ");
                  }
                }}
              ></Column>

              <Column
                field="Action"
                header="Action"
                body={this.actionTemplate}
                headerStyle={{ width: "10%", minWidth: "8rem" }}
                bodyStyle={{ textAlign: "center" }}
              ></Column>
            </DataTable>
          ) : null}

          {/* Add Edit BL Type */}
          <Dialog
            open={AddMasterModal}
            onClose={() => this.handleClose("AddMaster")}
            aria-labelledby="cha-form-dialog-title"
          >
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>{MasterID !== "" ? "Edit" : "Add"} Product Master</div>
              <div
                className="dialog-close"
                onClick={(e) => this.handleClose("AddMaster")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="CHA-dialog-content-area">
              <GridContainer>
                <GridItem md={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    name="ProductName"
                    id="chaNo"
                    label="Product Name*"
                    type="text"
                    value={productName}
                    onChange={(e) => this.handleChange(e, "productName")}
                    error={productNameErr}
                    helperText={productNameErrText}
                    inputProps={{ maxLength: 50 }}
                    fullWidth
                  />
                </GridItem>
                <GridItem xs={12}>
                  <div>
                    <div
                      style={{
                        // fontSize: "18px",
                        margin: "10px 0 5px",
                      }}
                    >
                      <label>Type</label>
                    </div>
                    <div style={{ display: "flex", gap: "30px" }}>
                      {/* <div className="field-radiobutton">
                        <RadioButton
                          inputId="raw"
                          name="Raw Material"
                          value="Raw Material"
                          onChange={(e) => this.handleChange(e, "type")}
                          checked={type === "Raw Material"}
                        />
                        <label
                          htmlFor="Raw Material"
                          style={{ marginLeft: "8px" }}
                        >
                          Raw Material
                        </label>
                      </div> */}

                      <div className="field-checkbox">
                        <Checkbox
                          inputId="raw"
                          value="Raw Material"
                          onChange={(e) => this.handleChange(e, "type")}
                          checked={this.state.type.includes("Raw Material")}
                        />
                        <label htmlFor="raw" style={{ marginLeft: "8px" }}>
                          Raw Material
                        </label>
                      </div>

                      {/* <div className="field-radiobutton">
                        <RadioButton
                          inputId="finished"
                          name="Finished Product"
                          value="Finished Product"
                          onChange={(e) => this.handleChange(e, "type")}
                          checked={type === "Finished Product"}
                        />
                        <label
                          htmlFor="Finished Product"
                          style={{ marginLeft: "8px" }}
                        >
                          Finished Product
                        </label>
                      </div> */}

                      <div className="field-checkbox">
                        <Checkbox
                          inputId="finished"
                          value="Finished Product"
                          onChange={(e) => this.handleChange(e, "type")}
                          checked={this.state.type.includes("Finished Product")}
                        />
                        <label htmlFor="finished" style={{ marginLeft: "8px" }}>
                          Finished Product
                        </label>
                      </div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handleClose("AddMaster")}
              >
               Cancel
              </Button>
              <Button
                className="primary-btn"
                onClick={(e) => this.AddMaster(e)}
                type="submit"
                disabled={this.state.loading}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          {/* Modal For Delete */}
          <Dialog
            open={DeleteMasterTypeModal}
            onClose={() => this.handleClose("DeleteMasterType")}
            aria-labelledby="cha-form-dialog-title"
          >
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>Delete Product Master</div>
              <div
                className="dialog-close"
                onClick={(e) => this.handleClose("DeleteMasterType")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="CHA-dialog-content-area">
              <h6>Are you sure want to delete?</h6>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handleClose("DeleteMasterType")}
              >
                Cancel
              </Button>
              <Button
                className="primary-btn"
                onClick={(e) => this.DeleteMasterType(e)}
                type="submit"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}
export default ProductMaster;
